import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const Cookies = () => {
  const router = useRouter();
  const [gtmIds, setGtmIds] = useState<string[]>([]);

  useEffect(() => {
    const partnerId = router.query?.partnerId;
    if (partnerId) {
      fetch(
        `/api/pat-public/gtm-partners?filter=${partnerId}&limit=200&page=0`,
        {
          headers: {
            Accept: 'application/json',
          },
        },
      )
        .then(resp => resp.json())
        .then(({ code }) => {
          setGtmIds([code]);
        });
    }
  }, []);

  useEffect(() => {
    // The popup overlay breaks cypress tests, so we avoid showing it in cypress
    if (
      (typeof window !== 'undefined' && window.Cypress) ||
      !(window as any).tarteaucitron
    )
      return;
    if (gtmIds.length > 0) {
      (window as any).tarteaucitron.user.multiplegoogletagmanagerId = gtmIds;
      ((window as any).tarteaucitron.job =
        (window as any).tarteaucitron.job || []).push(
        'multiplegoogletagmanager',
      );
    }
  }, [gtmIds]);

  return null;
};
export default Cookies;
